/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import get from 'lodash/get';
import Video from 'react-jw-player';
import extend from 'lodash/extend';

import Ad from '../../../../components/ad/ad';
import NotFound from '../../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import RelatedSlider from '../../../../components/related_slider/related_slider';
import GoogleIMAGenerator from '../../../../components/video_module/utils/video_module_ads';

// eslint-disable-next-line
class VideoIndexPage extends Component {
  constructor(props) {
    super();
    this.renderVideoPlaylist = this.renderVideoPlaylist.bind(this);
  }

  renderVideoPlaylist(playlist, index) {
    const { config } = this.props;
    const props = this.props;
    const adData = get(props, 'videoIndexPage.ads', {});
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );
    return [
      <RelatedSlider
        key={playlist.feedid}
        title={playlist.title}
        related={playlist.playlist}
        classNames={['related-slider--video-index']}
        slideClassNames={['video-slide--horizontal-tight']}
        config={config}
        responsive={[
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 2.15,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 100000,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4
            }
          }
        ]}
      />,
      index % 3 === 0 ? (
        <div className="video-index-page__ad-container" key={index}>
          <Ad {...combinedAdModel} pos="btf" name={`flexiblebillboard_${index/3 + 1}`} />
          <Ad {...combinedAdModel} pos="btf" name={index === 0 ? "mobileparallax_1" : `mobilerectangle_${index/3 + 1}`} />
        </div>
      ) : (
        ''
      )
    ];
  }

  render() {


    if (this.props.status === 404 || this.props.status === 500) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.videoIndexPage.isLoading) {
      return (
        <section className="video-page">
          <article className="video-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    return (
      <section className="video-index-page">
        <section className="video-index-page__video-wrapper">
          <Video
            playerId="video--index-page"
            playerScript="https://content.jwplatform.com/libraries/S002m6Rz.js"
            playlist={`https://fc-api.fastcompany.com/api/v1/jw-feed/0lmMve0i`}
            generatePrerollUrl={function generatePreRoll(video) {
              return new GoogleIMAGenerator(video.title, 'videohomepage').adTag;
            }}
            isAutoPlay={false}
            playInView={false}
            playInViewPercentage={10}
            className="jwplayer--video-post"
          />
        </section>

        <section>
          {get(this.props, 'jwPlaylistIndex.data.playlists', []).map(
            this.renderVideoPlaylist
          )}
        </section>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    videoIndexPage: state.videoIndexPage,
    jwPlaylistIndex: state.jwPlaylistIndex
  };
}

VideoIndexPage.propTypes = {
  config: PropTypes.shape({}).isRequired,
  status: PropTypes.number,
  videoIndexPage: PropTypes.shape({}),
  jwPlaylistIndex: PropTypes.shape({})
};

export default withRouter(connect(mapStateToProps)(VideoIndexPage));



// WEBPACK FOOTER //
// ./src/views/containers/pages/video/video_index_page/video_index_page.js